var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.componentType,
    _vm._b(
      {
        tag: "component",
        class: [_vm.$style["mds-tag"], _vm.sizeClass, _vm.classObject],
        attrs: { href: _vm.href, "data-mds-version": _vm.version },
      },
      "component",
      _vm.routingProps,
      false
    ),
    [
      _c(
        "div",
        { class: _vm.$style["mds-tag__text"] },
        [
          _vm._t("default", function () {
            return [_vm._v(_vm._s(_vm.text))]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.removable && !_vm.href
        ? _c("mds-button", {
            class: [_vm.$style["mds-tag__remove-button"]],
            attrs: {
              type: "button",
              icon: "remove",
              variation: "icon-only",
              size: "small",
              onDark: _vm.onDark || _vm.onBlack,
              text: _vm.removableAriaLabel,
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.$emit("mds-tag-removed", $event.target, $event)
              },
              click: function ($event) {
                return _vm.$emit("mds-tag-removed", $event.target, $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }